// Auto-generated by scripts/extract-certificates.js - do not hand-edit.
// Re-run `npm run extract:certificates` after adding or removing PDFs in
// "src/Pluralsight Certificates/" to regenerate this file and the images
// in "public/certificates/".

export const pluralsightCertificates = [
  {
    "slug": "designing-restful-web-apis",
    "title": "Designing RESTful Web APIs",
    "issuer": "Pluralsight",
    "date": "30 January, 2023",
    "hours": "2.1",
    "description": "Completed via Pluralsight after 2.1 hours of coursework.",
    "tags": [
      "Web Development"
    ],
    "image": "/certificates/designing-restful-web-apis.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "modern-browser-security-reports",
    "title": "Modern Browser Security Reports",
    "issuer": "Pluralsight",
    "date": "17 September, 2021",
    "hours": "1",
    "description": "Completed via Pluralsight after 1 hour of coursework.",
    "tags": [
      "Security"
    ],
    "image": "/certificates/modern-browser-security-reports.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "the-abcs-of-architecting-better-css",
    "title": "The ABCs of Architecting Better CSS",
    "issuer": "Pluralsight",
    "date": "22 May, 2021",
    "hours": "0.7",
    "description": "Completed via Pluralsight after 0.7 hours of coursework.",
    "tags": [
      "Web Design"
    ],
    "image": "/certificates/the-abcs-of-architecting-better-css.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "adobe-xd-cc-fundamentals",
    "title": "Adobe XD CC Fundamentals",
    "issuer": "Pluralsight",
    "date": "12 May, 2021",
    "hours": "2.8",
    "description": "Completed via Pluralsight after 2.8 hours of coursework.",
    "tags": [
      "Design"
    ],
    "image": "/certificates/adobe-xd-cc-fundamentals.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "managing-react-state",
    "title": "Managing React State",
    "issuer": "Pluralsight",
    "date": "4 May, 2021",
    "hours": "5.1",
    "description": "Completed via Pluralsight after 5.1 hours of coursework.",
    "tags": [
      "React"
    ],
    "image": "/certificates/managing-react-state.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "practical-html5",
    "title": "Practical HTML5",
    "issuer": "Pluralsight",
    "date": "3 May, 2021",
    "hours": "4.1",
    "description": "Completed via Pluralsight after 4.1 hours of coursework.",
    "tags": [
      "Web Design"
    ],
    "image": "/certificates/practical-html5.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "storing-data-in-html",
    "title": "Storing Data in HTML",
    "issuer": "Pluralsight",
    "date": "18 April, 2021",
    "hours": "0.6",
    "description": "Completed via Pluralsight after 0.6 hours of coursework.",
    "tags": [
      "Web Design"
    ],
    "image": "/certificates/storing-data-in-html.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "html-document-flow",
    "title": "HTML Document Flow",
    "issuer": "Pluralsight",
    "date": "17 April, 2021",
    "hours": "0.7",
    "description": "Completed via Pluralsight after 0.7 hours of coursework.",
    "tags": [
      "Web Design"
    ],
    "image": "/certificates/html-document-flow.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "advanced-javascript",
    "title": "Advanced JavaScript",
    "issuer": "Pluralsight",
    "date": "5 April, 2021",
    "hours": "6.9",
    "description": "Completed via Pluralsight after 6.9 hours of coursework.",
    "tags": [
      "JavaScript"
    ],
    "image": "/certificates/advanced-javascript.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "android-keyboard-inputs-getting-started",
    "title": "Android Keyboard Inputs: Getting Started",
    "issuer": "Pluralsight",
    "date": "5 April, 2021",
    "hours": "2",
    "description": "Completed via Pluralsight after 2 hours of coursework.",
    "tags": [
      "Android"
    ],
    "image": "/certificates/android-keyboard-inputs-getting-started.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "creating-layouts-with-css-grid",
    "title": "Creating Layouts with CSS Grid",
    "issuer": "Pluralsight",
    "date": "5 April, 2021",
    "hours": "1.7",
    "description": "Completed via Pluralsight after 1.7 hours of coursework.",
    "tags": [
      "Web Design",
      "Design"
    ],
    "image": "/certificates/creating-layouts-with-css-grid.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "debugging-sites-using-chrome-devtools",
    "title": "Debugging Sites Using Chrome DevTools",
    "issuer": "Pluralsight",
    "date": "5 April, 2021",
    "hours": "1.8",
    "description": "Completed via Pluralsight after 1.8 hours of coursework.",
    "tags": [
      "Web Development"
    ],
    "image": "/certificates/debugging-sites-using-chrome-devtools.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "github-getting-started",
    "title": "GitHub: Getting Started",
    "issuer": "Pluralsight",
    "date": "5 April, 2021",
    "hours": "4.1",
    "description": "Completed via Pluralsight after 4.1 hours of coursework.",
    "tags": [
      "Git"
    ],
    "image": "/certificates/github-getting-started.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "introduction-to-css",
    "title": "Introduction to CSS",
    "issuer": "Pluralsight",
    "date": "5 April, 2021",
    "hours": "2.2",
    "description": "Completed via Pluralsight after 2.2 hours of coursework.",
    "tags": [
      "Web Design"
    ],
    "image": "/certificates/introduction-to-css.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "premiere-pro-cc-titles",
    "title": "Premiere Pro CC Titles",
    "issuer": "Pluralsight",
    "date": "5 April, 2021",
    "hours": "1.3",
    "description": "Completed via Pluralsight after 1.3 hours of coursework.",
    "tags": [
      "Design"
    ],
    "image": "/certificates/premiere-pro-cc-titles.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "server-rendering-react-16-components",
    "title": "Server Rendering React 16 Components",
    "issuer": "Pluralsight",
    "date": "5 April, 2021",
    "hours": "1.5",
    "description": "Completed via Pluralsight after 1.5 hours of coursework.",
    "tags": [
      "React"
    ],
    "image": "/certificates/server-rendering-react-16-components.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "styling-react-components",
    "title": "Styling React Components",
    "issuer": "Pluralsight",
    "date": "5 April, 2021",
    "hours": "1.1",
    "description": "Completed via Pluralsight after 1.1 hours of coursework.",
    "tags": [
      "React"
    ],
    "image": "/certificates/styling-react-components.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "building-web-applications-with-nodejs-and-express-40-update",
    "title": "Building Web Applications with Node.js and Express 4.0 (UPDATE)",
    "issuer": "Pluralsight",
    "date": "27 December, 2020",
    "hours": "5.2",
    "description": "Completed via Pluralsight after 5.2 hours of coursework.",
    "tags": [
      "JavaScript"
    ],
    "image": "/certificates/building-web-applications-with-nodejs-and-express-40-update.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "machine-learning-on-android-demystified",
    "title": "Machine Learning on Android Demystified",
    "issuer": "Pluralsight",
    "date": "21 November, 2020",
    "hours": "0.7",
    "description": "Completed via Pluralsight after 0.7 hours of coursework.",
    "tags": [
      "Android"
    ],
    "image": "/certificates/machine-learning-on-android-demystified.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "creating-a-site-with-css-grid-and-bootstrap-4",
    "title": "Creating a Site with CSS Grid and Bootstrap 4",
    "issuer": "Pluralsight",
    "date": "4 November, 2020",
    "hours": "2.2",
    "description": "Completed via Pluralsight after 2.2 hours of coursework.",
    "tags": [
      "Web Design"
    ],
    "image": "/certificates/creating-a-site-with-css-grid-and-bootstrap-4.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "setting-up-a-java-development-environment",
    "title": "Setting up a Java Development Environment",
    "issuer": "Pluralsight",
    "date": "4 November, 2020",
    "hours": "0.8",
    "description": "Completed via Pluralsight after 0.8 hours of coursework.",
    "tags": [
      "Java"
    ],
    "image": "/certificates/setting-up-a-java-development-environment.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "design-patterns-in-java-behavioral",
    "title": "Design Patterns in Java: Behavioral",
    "issuer": "Pluralsight",
    "date": "3 November, 2020",
    "hours": "4.4",
    "description": "Completed via Pluralsight after 4.4 hours of coursework.",
    "tags": [
      "Java"
    ],
    "image": "/certificates/design-patterns-in-java-behavioral.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "introduction-to-enterprise-network-infrastructure",
    "title": "Introduction to Enterprise Network Infrastructure",
    "issuer": "Pluralsight",
    "date": "3 November, 2020",
    "hours": "3",
    "description": "Completed via Pluralsight after 3 hours of coursework.",
    "tags": [
      "Networking",
      "Professional Skills"
    ],
    "image": "/certificates/introduction-to-enterprise-network-infrastructure.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "whats-new-in-java-9",
    "title": "What's New in Java 9",
    "issuer": "Pluralsight",
    "date": "3 November, 2020",
    "hours": "3.6",
    "description": "Completed via Pluralsight after 3.6 hours of coursework.",
    "tags": [
      "Java"
    ],
    "image": "/certificates/whats-new-in-java-9.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "working-with-files-in-php",
    "title": "Working with Files in PHP",
    "issuer": "Pluralsight",
    "date": "3 November, 2020",
    "hours": "1.6",
    "description": "Completed via Pluralsight after 1.6 hours of coursework.",
    "tags": [
      "PHP"
    ],
    "image": "/certificates/working-with-files-in-php.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "hack-yourself-first-how-to-go-on-the-cyber-offense",
    "title": "Hack Yourself First: How to go on the Cyber-Offense",
    "issuer": "Pluralsight",
    "date": "2 November, 2020",
    "hours": "9.4",
    "description": "Completed via Pluralsight after 9.4 hours of coursework.",
    "tags": [
      "Security"
    ],
    "image": "/certificates/hack-yourself-first-how-to-go-on-the-cyber-offense.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "java-core-libraries-jdbc-4",
    "title": "Java Core Libraries: JDBC 4",
    "issuer": "Pluralsight",
    "date": "28 October, 2020",
    "hours": "1.8",
    "description": "Completed via Pluralsight after 1.8 hours of coursework.",
    "tags": [
      "Java"
    ],
    "image": "/certificates/java-core-libraries-jdbc-4.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "broadening-android-app-appeal-and-reach",
    "title": "Broadening Android App Appeal and Reach",
    "issuer": "Pluralsight",
    "date": "26 October, 2020",
    "hours": "4.1",
    "description": "Completed via Pluralsight after 4.1 hours of coursework.",
    "tags": [
      "Android"
    ],
    "image": "/certificates/broadening-android-app-appeal-and-reach.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "javafx-8-playbook-controls-with-data-model",
    "title": "JavaFX 8 Playbook: Controls with Data Model",
    "issuer": "Pluralsight",
    "date": "25 October, 2020",
    "hours": "3",
    "description": "Completed via Pluralsight after 3 hours of coursework.",
    "tags": [
      "Java"
    ],
    "image": "/certificates/javafx-8-playbook-controls-with-data-model.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "enhancing-the-android-application-experience",
    "title": "Enhancing the Android Application Experience",
    "issuer": "Pluralsight",
    "date": "24 October, 2020",
    "hours": "4.9",
    "description": "Completed via Pluralsight after 4.9 hours of coursework.",
    "tags": [
      "Android"
    ],
    "image": "/certificates/enhancing-the-android-application-experience.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "flutter-getting-started",
    "title": "Flutter: Getting Started",
    "issuer": "Pluralsight",
    "date": "20 October, 2020",
    "hours": "2.8",
    "description": "Completed via Pluralsight after 2.8 hours of coursework.",
    "tags": [
      "Flutter"
    ],
    "image": "/certificates/flutter-getting-started.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "java-se-8-building-your-first-javafx-application",
    "title": "Java SE 8: Building Your First JavaFX Application",
    "issuer": "Pluralsight",
    "date": "18 October, 2020",
    "hours": "2.1",
    "description": "Completed via Pluralsight after 2.1 hours of coursework.",
    "tags": [
      "Java"
    ],
    "image": "/certificates/java-se-8-building-your-first-javafx-application.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "ux-fundamentals",
    "title": "UX Fundamentals",
    "issuer": "Pluralsight",
    "date": "18 October, 2020",
    "hours": "1.1",
    "description": "Completed via Pluralsight after 1.1 hours of coursework.",
    "tags": [
      "Web Design"
    ],
    "image": "/certificates/ux-fundamentals.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "design-patterns-in-java-creational",
    "title": "Design Patterns in Java: Creational",
    "issuer": "Pluralsight",
    "date": "17 October, 2020",
    "hours": "1.9",
    "description": "Completed via Pluralsight after 1.9 hours of coursework.",
    "tags": [
      "Java"
    ],
    "image": "/certificates/design-patterns-in-java-creational.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "getting-started-with-nmap-7",
    "title": "Getting Started with Nmap 7",
    "issuer": "Pluralsight",
    "date": "16 October, 2020",
    "hours": "1.4",
    "description": "Completed via Pluralsight after 1.4 hours of coursework.",
    "tags": [
      "Security"
    ],
    "image": "/certificates/getting-started-with-nmap-7.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "introduction-to-penetration-testing-using-metasploit",
    "title": "Introduction to Penetration Testing Using Metasploit",
    "issuer": "Pluralsight",
    "date": "16 October, 2020",
    "hours": "3.6",
    "description": "Completed via Pluralsight after 3.6 hours of coursework.",
    "tags": [
      "Security"
    ],
    "image": "/certificates/introduction-to-penetration-testing-using-metasploit.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "metasploit-getting-started",
    "title": "Metasploit: Getting Started",
    "issuer": "Pluralsight",
    "date": "16 October, 2020",
    "hours": "2.1",
    "description": "Completed via Pluralsight after 2.1 hours of coursework.",
    "tags": [
      "Security"
    ],
    "image": "/certificates/metasploit-getting-started.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "color-theory-for-todays-creative-professionals",
    "title": "Color Theory for Today's Creative Professionals",
    "issuer": "Pluralsight",
    "date": "14 October, 2020",
    "hours": "1.2",
    "description": "Completed via Pluralsight after 1.2 hours of coursework.",
    "tags": [
      "Design"
    ],
    "image": "/certificates/color-theory-for-todays-creative-professionals.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "fundamentals-of-digital-drawing-in-photoshop",
    "title": "Fundamentals of Digital Drawing in Photoshop",
    "issuer": "Pluralsight",
    "date": "14 October, 2020",
    "hours": "1.8",
    "description": "Completed via Pluralsight after 1.8 hours of coursework.",
    "tags": [
      "Design"
    ],
    "image": "/certificates/fundamentals-of-digital-drawing-in-photoshop.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "keys-to-amazing-graphic-design-layouts",
    "title": "Keys to Amazing Graphic Design Layouts",
    "issuer": "Pluralsight",
    "date": "14 October, 2020",
    "hours": "2.2",
    "description": "Completed via Pluralsight after 2.2 hours of coursework.",
    "tags": [
      "Design"
    ],
    "image": "/certificates/keys-to-amazing-graphic-design-layouts.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "rapid-es6-training",
    "title": "Rapid ES6 Training",
    "issuer": "Pluralsight",
    "date": "14 October, 2020",
    "hours": "4.3",
    "description": "Completed via Pluralsight after 4.3 hours of coursework.",
    "tags": [
      "JavaScript"
    ],
    "image": "/certificates/rapid-es6-training.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "react-native-fundamentals",
    "title": "React Native Fundamentals",
    "issuer": "Pluralsight",
    "date": "14 October, 2020",
    "hours": "2.6",
    "description": "Completed via Pluralsight after 2.6 hours of coursework.",
    "tags": [
      "React"
    ],
    "image": "/certificates/react-native-fundamentals.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "design-patterns-in-java-structural",
    "title": "Design Patterns in Java: Structural",
    "issuer": "Pluralsight",
    "date": "13 October, 2020",
    "hours": "2.9",
    "description": "Completed via Pluralsight after 2.9 hours of coursework.",
    "tags": [
      "Java"
    ],
    "image": "/certificates/design-patterns-in-java-structural.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "getting-started-with-augmented-reality-on-android-devices",
    "title": "Getting Started with Augmented Reality on Android Devices",
    "issuer": "Pluralsight",
    "date": "13 October, 2020",
    "hours": "3.1",
    "description": "Completed via Pluralsight after 3.1 hours of coursework.",
    "tags": [
      "Android"
    ],
    "image": "/certificates/getting-started-with-augmented-reality-on-android-devices.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "android-animations",
    "title": "Android Animations",
    "issuer": "Pluralsight",
    "date": "12 October, 2020",
    "hours": "2.3",
    "description": "Completed via Pluralsight after 2.3 hours of coursework.",
    "tags": [
      "Android"
    ],
    "image": "/certificates/android-animations.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "firebase-on-android-cloud-messaging-cloud-functions-and-crashlytics",
    "title": "Firebase on Android: Cloud Messaging, Cloud Functions and Crashlytics",
    "issuer": "Pluralsight",
    "date": "12 October, 2020",
    "hours": "2.1",
    "description": "Completed via Pluralsight after 2.1 hours of coursework.",
    "tags": [
      "Android",
      "Firebase"
    ],
    "image": "/certificates/firebase-on-android-cloud-messaging-cloud-functions-and-crashlytics.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "android-fundamentals-localization-and-internationalization",
    "title": "Android Fundamentals: Localization and Internationalization",
    "issuer": "Pluralsight",
    "date": "25 September, 2020",
    "hours": "2.4",
    "description": "Completed via Pluralsight after 2.4 hours of coursework.",
    "tags": [
      "Android"
    ],
    "image": "/certificates/android-fundamentals-localization-and-internationalization.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "less-4-getting-started",
    "title": "Less 4: Getting Started",
    "issuer": "Pluralsight",
    "date": "25 September, 2020",
    "hours": "1.2",
    "description": "Completed via Pluralsight after 1.2 hours of coursework.",
    "tags": [
      "Web Design"
    ],
    "image": "/certificates/less-4-getting-started.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "android-fundamentals-common-actions-using-intents",
    "title": "Android Fundamentals: Common Actions Using Intents",
    "issuer": "Pluralsight",
    "date": "20 September, 2020",
    "hours": "1.4",
    "description": "Completed via Pluralsight after 1.4 hours of coursework.",
    "tags": [
      "Android"
    ],
    "image": "/certificates/android-fundamentals-common-actions-using-intents.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "angular-forms",
    "title": "Angular Forms",
    "issuer": "Pluralsight",
    "date": "20 September, 2020",
    "hours": "2.1",
    "description": "Completed via Pluralsight after 2.1 hours of coursework.",
    "tags": [
      "Angular"
    ],
    "image": "/certificates/angular-forms.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "working-with-classes-and-interfaces-in-java-11",
    "title": "Working with Classes and Interfaces in Java 11",
    "issuer": "Pluralsight",
    "date": "20 September, 2020",
    "hours": "4.8",
    "description": "Completed via Pluralsight after 4.8 hours of coursework.",
    "tags": [
      "Java"
    ],
    "image": "/certificates/working-with-classes-and-interfaces-in-java-11.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "overcoming-common-android-performance-barriers",
    "title": "Overcoming Common Android Performance Barriers",
    "issuer": "Pluralsight",
    "date": "16 September, 2020",
    "hours": "2.1",
    "description": "Completed via Pluralsight after 2.1 hours of coursework.",
    "tags": [
      "Android"
    ],
    "image": "/certificates/overcoming-common-android-performance-barriers.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "java-8-fundamentals-the-java-reflection-api-method-handles",
    "title": "Java 8 Fundamentals: The Java Reflection API Method Handles",
    "issuer": "Pluralsight",
    "date": "15 September, 2020",
    "hours": "3.2",
    "description": "Completed via Pluralsight after 3.2 hours of coursework.",
    "tags": [
      "Java",
      "Web Development"
    ],
    "image": "/certificates/java-8-fundamentals-the-java-reflection-api-method-handles.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "html-fundamentals",
    "title": "HTML Fundamentals",
    "issuer": "Pluralsight",
    "date": "14 September, 2020",
    "hours": "2.8",
    "description": "Completed via Pluralsight after 2.8 hours of coursework.",
    "tags": [
      "Web Design"
    ],
    "image": "/certificates/html-fundamentals.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "javascript-3-objects-and-prototypes",
    "title": "JavaScript 3 Objects and Prototypes",
    "issuer": "Pluralsight",
    "date": "14 September, 2020",
    "hours": "0.8",
    "description": "Completed via Pluralsight after 0.8 hours of coursework.",
    "tags": [
      "JavaScript"
    ],
    "image": "/certificates/javascript-3-objects-and-prototypes.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "semantic-html",
    "title": "Semantic HTML",
    "issuer": "Pluralsight",
    "date": "14 September, 2020",
    "hours": "1.8",
    "description": "Completed via Pluralsight after 1.8 hours of coursework.",
    "tags": [
      "Web Design"
    ],
    "image": "/certificates/semantic-html.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "exposing-data-and-information-outside-your-android-app",
    "title": "Exposing Data and Information Outside Your Android App",
    "issuer": "Pluralsight",
    "date": "13 September, 2020",
    "hours": "2.9",
    "description": "Completed via Pluralsight after 2.9 hours of coursework.",
    "tags": [
      "Android"
    ],
    "image": "/certificates/exposing-data-and-information-outside-your-android-app.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "android-5-security-inter-app-and-network-communication-security",
    "title": "Android 5 Security: Inter-app and Network Communication Security",
    "issuer": "Pluralsight",
    "date": "11 September, 2020",
    "hours": "0.7",
    "description": "Completed via Pluralsight after 0.7 hours of coursework.",
    "tags": [
      "Security",
      "Android",
      "Networking"
    ],
    "image": "/certificates/android-5-security-inter-app-and-network-communication-security.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "firebase-on-android-real-time-database-and-cloud-storage",
    "title": "Firebase on Android: Real-time Database and Cloud Storage",
    "issuer": "Pluralsight",
    "date": "11 September, 2020",
    "hours": "2.1",
    "description": "Completed via Pluralsight after 2.1 hours of coursework.",
    "tags": [
      "Android",
      "Firebase"
    ],
    "image": "/certificates/firebase-on-android-real-time-database-and-cloud-storage.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "progressive-web-app-fundamentals",
    "title": "Progressive Web App Fundamentals",
    "issuer": "Pluralsight",
    "date": "10 September, 2020",
    "hours": "2.9",
    "description": "Completed via Pluralsight after 2.9 hours of coursework.",
    "tags": [
      "Web Development"
    ],
    "image": "/certificates/progressive-web-app-fundamentals.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "using-the-java-nio-api",
    "title": "Using the Java NIO API",
    "issuer": "Pluralsight",
    "date": "10 September, 2020",
    "hours": "0.9",
    "description": "Completed via Pluralsight after 0.9 hours of coursework.",
    "tags": [
      "Java",
      "Web Development"
    ],
    "image": "/certificates/using-the-java-nio-api.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "good-parts-of-javascript-and-the-web",
    "title": "Good Parts of JavaScript and the Web",
    "issuer": "Pluralsight",
    "date": "27 August, 2020",
    "hours": "10.9",
    "description": "Completed via Pluralsight after 10.9 hours of coursework.",
    "tags": [
      "JavaScript"
    ],
    "image": "/certificates/good-parts-of-javascript-and-the-web.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "firebase-on-android-user-email-authentication-and-verification",
    "title": "Firebase on Android: User Email Authentication and Verification",
    "issuer": "Pluralsight",
    "date": "26 August, 2020",
    "hours": "1.2",
    "description": "Completed via Pluralsight after 1.2 hours of coursework.",
    "tags": [
      "Android",
      "Firebase"
    ],
    "image": "/certificates/firebase-on-android-user-email-authentication-and-verification.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "introduction-to-emotional-intelligence",
    "title": "Introduction to Emotional Intelligence",
    "issuer": "Pluralsight",
    "date": "23 August, 2020",
    "hours": "2.1",
    "description": "Completed via Pluralsight after 2.1 hours of coursework.",
    "tags": [
      "Professional Skills"
    ],
    "image": "/certificates/introduction-to-emotional-intelligence.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "angular-getting-started",
    "title": "Angular: Getting Started",
    "issuer": "Pluralsight",
    "date": "21 August, 2020",
    "hours": "5.9",
    "description": "Completed via Pluralsight after 5.9 hours of coursework.",
    "tags": [
      "Angular"
    ],
    "image": "/certificates/angular-getting-started.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "mobile-first-responsive-web-design",
    "title": "Mobile First Responsive Web Design",
    "issuer": "Pluralsight",
    "date": "20 August, 2020",
    "hours": "3",
    "description": "Completed via Pluralsight after 3 hours of coursework.",
    "tags": [
      "Web Design"
    ],
    "image": "/certificates/mobile-first-responsive-web-design.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "introduction-to-css-for-designers",
    "title": "Introduction to CSS for Designers",
    "issuer": "Pluralsight",
    "date": "19 August, 2020",
    "hours": "1.8",
    "description": "Completed via Pluralsight after 1.8 hours of coursework.",
    "tags": [
      "Web Design"
    ],
    "image": "/certificates/introduction-to-css-for-designers.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "angular-cli",
    "title": "Angular CLI",
    "issuer": "Pluralsight",
    "date": "17 August, 2020",
    "hours": "3.1",
    "description": "Completed via Pluralsight after 3.1 hours of coursework.",
    "tags": [
      "Angular"
    ],
    "image": "/certificates/angular-cli.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "building-a-javascript-development-environment",
    "title": "Building a JavaScript Development Environment",
    "issuer": "Pluralsight",
    "date": "17 August, 2020",
    "hours": "4.9",
    "description": "Completed via Pluralsight after 4.9 hours of coursework.",
    "tags": [
      "JavaScript"
    ],
    "image": "/certificates/building-a-javascript-development-environment.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "android-4-security-effective-permission-handling",
    "title": "Android 4 Security: Effective Permission Handling",
    "issuer": "Pluralsight",
    "date": "15 August, 2020",
    "hours": "1",
    "description": "Completed via Pluralsight after 1 hour of coursework.",
    "tags": [
      "Security",
      "Android"
    ],
    "image": "/certificates/android-4-security-effective-permission-handling.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "leveraging-the-power-of-the-android-platform",
    "title": "Leveraging the Power of the Android Platform",
    "issuer": "Pluralsight",
    "date": "15 August, 2020",
    "hours": "3.1",
    "description": "Completed via Pluralsight after 3.1 hours of coursework.",
    "tags": [
      "Android"
    ],
    "image": "/certificates/leveraging-the-power-of-the-android-platform.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "android-8-getting-started-with-retrofit",
    "title": "Android 8: Getting Started with Retrofit",
    "issuer": "Pluralsight",
    "date": "12 August, 2020",
    "hours": "2.3",
    "description": "Completed via Pluralsight after 2.3 hours of coursework.",
    "tags": [
      "Android"
    ],
    "image": "/certificates/android-8-getting-started-with-retrofit.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "android-8-image-processing-with-picasso",
    "title": "Android 8: Image Processing with Picasso",
    "issuer": "Pluralsight",
    "date": "12 August, 2020",
    "hours": "2",
    "description": "Completed via Pluralsight after 2 hours of coursework.",
    "tags": [
      "Android"
    ],
    "image": "/certificates/android-8-image-processing-with-picasso.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "android-gestures-getting-started",
    "title": "Android Gestures: Getting Started",
    "issuer": "Pluralsight",
    "date": "12 August, 2020",
    "hours": "2.3",
    "description": "Completed via Pluralsight after 2.3 hours of coursework.",
    "tags": [
      "Android"
    ],
    "image": "/certificates/android-gestures-getting-started.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "angular-6-the-big-picture",
    "title": "Angular 6: The Big Picture",
    "issuer": "Pluralsight",
    "date": "6 August, 2020",
    "hours": "1.2",
    "description": "Completed via Pluralsight after 1.2 hours of coursework.",
    "tags": [
      "Angular"
    ],
    "image": "/certificates/angular-6-the-big-picture.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "android-fundamentals-data-binding",
    "title": "Android Fundamentals: Data Binding",
    "issuer": "Pluralsight",
    "date": "2 May, 2020",
    "hours": "1.6",
    "description": "Completed via Pluralsight after 1.6 hours of coursework.",
    "tags": [
      "Android"
    ],
    "image": "/certificates/android-fundamentals-data-binding.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "java-8-fundamentals-the-core-platform",
    "title": "Java 8 Fundamentals: The Core Platform",
    "issuer": "Pluralsight",
    "date": "2 May, 2020",
    "hours": "7.4",
    "description": "Completed via Pluralsight after 7.4 hours of coursework.",
    "tags": [
      "Java"
    ],
    "image": "/certificates/java-8-fundamentals-the-core-platform.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "mastering-java-swing-part-1",
    "title": "Mastering Java Swing - Part 1",
    "issuer": "Pluralsight",
    "date": "2 May, 2020",
    "hours": "3.6",
    "description": "Completed via Pluralsight after 3.6 hours of coursework.",
    "tags": [
      "Java"
    ],
    "image": "/certificates/mastering-java-swing-part-1.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "css-positioning",
    "title": "CSS Positioning",
    "issuer": "Pluralsight",
    "date": "30 April, 2020",
    "hours": "0.8",
    "description": "Completed via Pluralsight after 0.8 hours of coursework.",
    "tags": [
      "Web Design"
    ],
    "image": "/certificates/css-positioning.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "networking-concepts-and-protocols",
    "title": "Networking Concepts and Protocols",
    "issuer": "Pluralsight",
    "date": "27 April, 2020",
    "hours": "5.4",
    "description": "Completed via Pluralsight after 5.4 hours of coursework.",
    "tags": [
      "Networking"
    ],
    "image": "/certificates/networking-concepts-and-protocols.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "java-fundamentals-httpclient",
    "title": "Java Fundamentals: HttpClient",
    "issuer": "Pluralsight",
    "date": "12 April, 2020",
    "hours": "1.7",
    "description": "Completed via Pluralsight after 1.7 hours of coursework.",
    "tags": [
      "Java"
    ],
    "image": "/certificates/java-fundamentals-httpclient.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "how-git-works",
    "title": "How Git Works",
    "issuer": "Pluralsight",
    "date": "28 May, 2019",
    "hours": "1.9",
    "description": "Completed via Pluralsight after 1.9 hours of coursework.",
    "tags": [
      "Git"
    ],
    "image": "/certificates/how-git-works.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "working-with-android-tools-and-testing",
    "title": "Working with Android Tools and Testing",
    "issuer": "Pluralsight",
    "date": "24 May, 2019",
    "hours": "2.9",
    "description": "Completed via Pluralsight after 2.9 hours of coursework.",
    "tags": [
      "Android"
    ],
    "image": "/certificates/working-with-android-tools-and-testing.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "managing-android-app-data-with-sqlite",
    "title": "Managing Android App Data with SQLite",
    "issuer": "Pluralsight",
    "date": "23 May, 2019",
    "hours": "4.5",
    "description": "Completed via Pluralsight after 4.5 hours of coursework.",
    "tags": [
      "Android"
    ],
    "image": "/certificates/managing-android-app-data-with-sqlite.jpg",
    "credentialUrl": ""
  },
  {
    "slug": "understanding-android-application-basics",
    "title": "Understanding Android Application Basics",
    "issuer": "Pluralsight",
    "date": "7 May, 2019",
    "hours": "4.3",
    "description": "Completed via Pluralsight after 4.3 hours of coursework.",
    "tags": [
      "Android"
    ],
    "image": "/certificates/understanding-android-application-basics.jpg",
    "credentialUrl": ""
  }
];
